import { fromJS, Map as ImmutableMap } from 'immutable';
import { Reducer } from 'redux';

import type { TypedMap } from 'utils/typed-map';

import { ADD_MULTIPLE } from './constants';
import WalletTransaction from './model';

export type WalletTransactionMap = ImmutableMap<string, WalletTransaction>;

export type WalletTransactionState = TypedMap<{
  walletTransactions: WalletTransactionMap;
}>;

export const initialState: WalletTransactionState = fromJS({
  walletTransactions: ImmutableMap(),
});

const walletTransactionReducer: Reducer = (
  state = initialState,
  action
): WalletTransactionState => {
  switch (action.type) {
    case ADD_MULTIPLE:
      return state.set(
        'walletTransactions',
        state.get('walletTransactions').merge(action.walletTransactions)
      );

    default:
      return state;
  }
};

export default walletTransactionReducer;
